<template>
  <div class="root-container">
    <div class="table-container">
      <!-- 搜索栏 -->
      <div class="search-container" :class="{ 'mobile-search-top': !isDesktop }">
        <!-- 电脑端 -->
        <div v-if="isDesktop" class="desktop-search-wrapper">
          <div class="search-row">
            <el-input
              v-model="searchKeyword"
              placeholder="搜索姓名/邮箱/公司"
              prefix-icon="el-icon-search"
              class="search-input"
              @keyup.enter="handleSearch"
            >
              <template slot="append">
                <el-button @click="handleSearch">搜索</el-button>
              </template>
            </el-input>

            <div class="button-group">
              <el-button type="primary" size="small" icon="el-icon-filter" @click="toggleFilter" class="filter-button">
                {{ isFilterOpen ? '收起筛选' : '展开筛选' }}
              </el-button>
            </div>
          </div>

          <!-- 电脑端筛选面板 -->
          <div v-if="isFilterOpen" class="filter-panel">
            <div class="filter-row">
              <div class="filter-item">
                <label>分类：</label>
                <el-select v-model="filterForm.category_id" placeholder="选择分类" clearable style="width: 150px;">
                  <el-option
                    v-for="cat in categoryOptions"
                    :key="cat.id"
                    :label="cat.name"
                    :value="cat.id"
                  />
                </el-select>
              </div>
              <div class="filter-item">
                <label>状态：</label>
                <el-select v-model="filterForm.status" placeholder="处理状态" clearable style="width: 150px;">
                  <el-option label="未读" :value="0" />
                  <el-option label="已读" :value="1" />
                  <el-option label="已回复" :value="2" />
                </el-select>
              </div>
            </div>
            <div class="filter-actions">
              <div class="applied-filters">
                <span v-if="!filterForm.category_id && !filterForm.status" class="filter-tag filter-tag-empty">
                  当前无筛选条件
                </span>
                <span v-if="filterForm.category_id" class="filter-tag">
                  分类：{{ getFilterCategoryName(filterForm.category_id) }}
                  <i class="el-icon-close" style="margin-left:5px;cursor:pointer;" @click="filterForm.category_id = ''"></i>
                </span>
                <span v-if="filterForm.status !== '' && filterForm.status !== null" class="filter-tag">
                  状态：{{ statusLabel(filterForm.status) }}
                  <i class="el-icon-close" style="margin-left:5px;cursor:pointer;" @click="filterForm.status = ''"></i>
                </span>
              </div>
              <div class="filter-buttons">
                <el-button size="small" @click="resetFilter">重置筛选</el-button>
                <el-button type="primary" size="small" @click="applyFilter">应用筛选</el-button>
              </div>
            </div>
          </div>
        </div>

        <!-- 手机端 -->
        <div v-else class="mobile-search-wrapper">
          <div v-if="isFilterOpen" class="mobile-filter-panel">
            <div class="mobile-applied-filters">
              <div v-if="!filterForm.category_id && filterForm.status === ''" class="applied-tags">
                <span class="mobile-filter-tag empty">当前无筛选条件</span>
              </div>
            </div>
            <div class="mobile-filter-actions">
              <van-button type="default" size="small" @click="resetFilter">重置</van-button>
              <van-button type="primary" size="small" @click="applyFilter">应用</van-button>
            </div>
          </div>

          <div class="mobile-filter-toggle" @click="toggleFilter">
            <van-icon :name="isFilterOpen ? 'arrow-up' : 'arrow-down'" />
            <span>{{ isFilterOpen ? '收起筛选' : '展开筛选' }}</span>
          </div>
        </div>
      </div>

      <!-- 内容区域 -->
      <div class="content-container">
        <!-- 电脑端表格 -->
        <div class="table-wrapper" v-if="isDesktop">
          <el-table :data="list" style="width: 100%" tooltip-effect="dark" empty-text="暂无数据"
            class="desktop-table" :height="tableHeight">
            <el-table-column prop="id" label="ID" width="70" align="center" />
            <el-table-column prop="category_name" label="分类" width="120" align="left" />
            <el-table-column prop="name" label="姓名" width="100" align="left" />
            <el-table-column prop="email" label="邮箱" width="180" align="left" />
            <el-table-column prop="phone" label="电话" width="130" align="left" />
            <el-table-column prop="company" label="公司" width="140" align="left" />
            <el-table-column label="地区" width="160" align="left">
              <template slot-scope="scope">
                <span v-if="scope.row.country">{{ scope.row.country }}</span>
                <span v-if="scope.row.prov"> · {{ scope.row.prov }}</span>
                <span v-if="scope.row.city"> · {{ scope.row.city }}</span>
                <span v-if="!scope.row.country && !scope.row.prov && !scope.row.city">-</span>
              </template>
            </el-table-column>
            <el-table-column prop="message" label="内容" min-width="200" align="left" show-overflow-tooltip />
            <el-table-column prop="status" label="状态" width="90" align="center">
              <template slot-scope="scope">
                <el-tag :type="statusTagType(scope.row.status)" size="small">{{ statusLabel(scope.row.status) }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="created_at" label="提交时间" width="170" align="left" />
            <el-table-column label="操作" width="155" align="right" fixed="right">
              <template slot-scope="scope">
                <div class="table-actions">
                  <el-link @click="handleView(scope.row)">
                    <i class="el-icon-view" style="font-size:16px;"></i>查看
                  </el-link>
                  <el-dropdown @command="command($event, scope.row)">
                    <span class="el-dropdown-link">
                      更多操作
                      <i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-if="scope.row.status === 0" command="read">标为已读</el-dropdown-item>
                      <el-dropdown-item command="remove">删除</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 手机端卡片 -->
        <div v-else class="mobile-cards">
          <div v-if="list.length === 0" class="mobile-empty">暂无数据</div>
          <div v-for="item in list" :key="item.id" class="mobile-card">
            <div class="card-header">
              <div class="card-title">
                <h3>{{ item.name }}</h3>
                <div style="display:flex;align-items:center;gap:8px;">
                  <el-tag :type="statusTagType(item.status)" size="small">{{ statusLabel(item.status) }}</el-tag>
                  <span style="font-size:12px;color:var(--text-200);">{{ item.created_at }}</span>
                </div>
              </div>
            </div>
            <div class="card-content">
              <p v-if="item.category_name"><strong>分类：</strong>{{ item.category_name }}</p>
              <p><strong>邮箱：</strong>{{ item.email }}</p>
              <p v-if="item.phone"><strong>电话：</strong>{{ item.phone }}</p>
              <p v-if="item.company"><strong>公司：</strong>{{ item.company }}</p>
              <p v-if="item.country || item.prov || item.city"><strong>地区：</strong>{{ [item.country, item.prov, item.city].filter(Boolean).join(' · ') }}</p>
              <p v-if="item.message"><strong>内容：</strong>{{ item.message }}</p>
            </div>
            <div class="card-actions">
              <van-button type="primary" size="small" @click="handleView(item)">查看</van-button>
              <van-button v-if="item.status === 0" type="warning" size="small" @click="handleMarkRead(item.id)">标为已读</van-button>
              <van-button type="danger" size="small" @click="handleDelete(item.id)">删除</van-button>
            </div>
          </div>
        </div>
      </div>

      <!-- 分页 -->
      <div v-if="isDesktop && total > 0" class="pagination-container">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          :current-page.sync="params.page"
          :page-sizes="[10, 20, 50]"
          :page-size.sync="params.page_count"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>

    <!-- 查看详情 Drawer -->
    <template v-if="isDesktop">
      <el-drawer title="" :visible.sync="detailVisible" size="520px" :show-close="false" class="contact-detail-drawer">
        <div v-if="currentItem" class="detail-content">
          <!-- 头部 -->
          <div class="detail-header">
            <div class="detail-header-info">
              <div class="detail-avatar">
                <i class="el-icon-user"></i>
              </div>
              <div class="detail-header-text">
                <h3>{{ currentItem.name }}</h3>
                <p v-if="currentItem.company">{{ currentItem.company }}</p>
              </div>
            </div>
            <div class="detail-header-meta">
              <el-tag :type="statusTagType(currentItem.status)" size="small" effect="dark">
                {{ statusLabel(currentItem.status) }}
              </el-tag>
              <span class="detail-time">{{ currentItem.created_at }}</span>
            </div>
          </div>

          <!-- 联系方式卡片 -->
          <div class="detail-contact-card">
            <div class="contact-item" v-if="currentItem.email">
              <div class="contact-icon email-icon">
                <i class="el-icon-message"></i>
              </div>
              <div class="contact-info">
                <span class="contact-label">邮箱</span>
                <span class="contact-value">{{ currentItem.email }}</span>
              </div>
            </div>
            <div class="contact-item" v-if="currentItem.phone">
              <div class="contact-icon phone-icon">
                <i class="el-icon-phone"></i>
              </div>
              <div class="contact-info">
                <span class="contact-label">电话</span>
                <span class="contact-value">{{ currentItem.phone }}</span>
              </div>
            </div>
            <div class="contact-item" v-if="currentItem.category_name">
              <div class="contact-icon category-icon">
                <i class="el-icon-collection-tag"></i>
              </div>
              <div class="contact-info">
                <span class="contact-label">分类</span>
                <span class="contact-value">{{ currentItem.category_name }}</span>
              </div>
            </div>
            <div class="contact-item" v-if="currentItem.country || currentItem.prov || currentItem.city">
              <div class="contact-icon location-icon">
                <i class="el-icon-location"></i>
              </div>
              <div class="contact-info">
                <span class="contact-label">地区</span>
                <span class="contact-value">{{ [currentItem.country, currentItem.prov, currentItem.city].filter(Boolean).join(' · ') }}</span>
              </div>
            </div>
          </div>

          <!-- 留言内容 -->
          <div class="detail-message-card">
            <div class="message-card-title">
              <i class="el-icon-chat-dot-round"></i>
              <span>留言内容</span>
            </div>
            <div class="detail-message-text">{{ currentItem.message }}</div>
          </div>
        </div>
      </el-drawer>
    </template>
    <template v-else>
      <van-popup v-model="detailVisible" position="bottom" :round="true" :style="{ height: '85%' }" closeable>
        <div class="popup-header" v-if="currentItem">
          <div class="popup-user-info">
            <div class="popup-avatar">
              <i class="el-icon-user"></i>
            </div>
            <div class="popup-user-text">
              <h3>{{ currentItem.name }}</h3>
              <p v-if="currentItem.company">{{ currentItem.company }}</p>
            </div>
          </div>
        </div>
        <div class="popup-content" v-if="currentItem">
          <div class="popup-status-row">
            <el-tag :type="statusTagType(currentItem.status)" size="small" effect="dark">
              {{ statusLabel(currentItem.status) }}
            </el-tag>
            <span class="popup-time">{{ currentItem.created_at }}</span>
          </div>

          <div class="popup-contact-list">
            <div class="popup-contact-item" v-if="currentItem.category_name">
              <div class="popup-contact-icon category-icon"><i class="el-icon-collection-tag"></i></div>
              <div class="popup-contact-info">
                <span class="popup-contact-label">分类</span>
                <span class="popup-contact-value">{{ currentItem.category_name }}</span>
              </div>
            </div>
            <div class="popup-contact-item" v-if="currentItem.email">
              <div class="popup-contact-icon email-icon"><i class="el-icon-message"></i></div>
              <div class="popup-contact-info">
                <span class="popup-contact-label">邮箱</span>
                <span class="popup-contact-value">{{ currentItem.email }}</span>
              </div>
            </div>
            <div class="popup-contact-item" v-if="currentItem.phone">
              <div class="popup-contact-icon phone-icon"><i class="el-icon-phone"></i></div>
              <div class="popup-contact-info">
                <span class="popup-contact-label">电话</span>
                <span class="popup-contact-value">{{ currentItem.phone }}</span>
              </div>
            </div>
            <div class="popup-contact-item" v-if="currentItem.country || currentItem.prov || currentItem.city">
              <div class="popup-contact-icon location-icon"><i class="el-icon-location"></i></div>
              <div class="popup-contact-info">
                <span class="popup-contact-label">地区</span>
                <span class="popup-contact-value">{{ [currentItem.country, currentItem.prov, currentItem.city].filter(Boolean).join(' · ') }}</span>
              </div>
            </div>
          </div>

          <div class="popup-message-card">
            <div class="popup-message-title">
              <i class="el-icon-chat-dot-round"></i>
              <span>留言内容</span>
            </div>
            <div class="popup-message-text">{{ currentItem.message }}</div>
          </div>
        </div>
      </van-popup>
    </template>
  </div>
</template>

<script>
import { getContactCategories, getContactSubmissions, updateContactSubmission, deleteContactSubmission } from "@/api/website"

export default {
  name: 'ContactSubmissionsPage',
  data() {
    return {
      isDesktop: true,
      searchKeyword: '',
      isFilterOpen: false,
      filterForm: {
        category_id: '',
        status: ''
      },
      params: {
        page: 1,
        page_count: 10
      },
      list: [],
      total: 0,
      categoryOptions: [],
      detailVisible: false,
      currentItem: null
    }
  },
  computed: {
    tableHeight() {
      if (!this.isDesktop) return 'auto'
      // 计算表格高度：减去顶部栏、筛选区域、分页栏和底部的高度
      const headerHeight = 60 // 顶部栏高度
      const searchHeight = this.isFilterOpen ? 200 : 60 // 搜索栏高度（包含筛选面板）
      const paginationHeight = 60 // 分页栏高度
      const footerHeight = 40 // 底部高度
      const padding = 20 // 页面内边距
      return window.innerHeight - headerHeight - searchHeight - paginationHeight - footerHeight - padding - 120 // 100是其他元素的额外高度
    }
  },
  mounted() {
    this.checkScreenSize()
    window.addEventListener('resize', this.handleResize)
    this.getCategoryOptions()
    this.getList()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      this.checkScreenSize()
    },
    checkScreenSize() {
      this.isDesktop = window.innerWidth > 768
    },
    getCategoryOptions() {
      getContactCategories().then(function(res) {
        if (res.code === 200) {
          var list = res.data || []
          var options = []
          list.forEach(function(item) {
            var zhName = item.translations && item.translations.zh ? item.translations.zh.name : ''
            if (zhName) {
              options.push({ id: item.id, name: zhName })
            }
          })
          this.categoryOptions = options
        }
      }.bind(this))
    },
    getFilterCategoryName(id) {
      var cat = this.categoryOptions.find(function(c) { return c.id === id })
      return cat ? cat.name : ''
    },
    handleSearch() {
      this.params.page = 1
      this.getList()
    },
    toggleFilter() {
      this.isFilterOpen = !this.isFilterOpen
    },
    applyFilter() {
      this.params.page = 1
      this.getList()
    },
    resetFilter() {
      this.filterForm = { category_id: '', status: '' }
      this.params.page = 1
      this.getList()
    },
    getList() {
      var data = {
        page_count: this.params.page_count,
        page: this.params.page
      }
      if (this.searchKeyword) data.keyword = this.searchKeyword
      if (this.filterForm.category_id !== '' && this.filterForm.category_id !== null) data.category_id = this.filterForm.category_id
      if (this.filterForm.status !== '' && this.filterForm.status !== null) data.status = this.filterForm.status

      getContactSubmissions(data).then(function(res) {
        if (res.code === 200) {
          this.list = res.data.data || []
          this.total = res.data.total || 0
        }
      }.bind(this))
    },
    handleSizeChange(val) {
      this.params.page_count = val
      this.params.page = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.params.page = val
      this.getList()
    },
    handleView(row) {
      this.currentItem = Object.assign({}, row)
      this.detailVisible = true
      if (row.status === 0) {
        this.handleMarkRead(row.id)
      }
    },
    handleMarkRead(id) {
      updateContactSubmission(id, { status: 1 }).then(function(res) {
        if (res.code === 200) {
          this.getList()
        }
      }.bind(this))
    },
    command(cmd, row) {
      if (cmd === 'read') {
        this.handleMarkRead(row.id)
      } else if (cmd === 'remove') {
        this.handleDelete(row.id)
      }
    },
    handleDelete(id) {
      this.$confirm('确定要删除这条记录吗？', '确定', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function() {
        return deleteContactSubmission(id)
      }).then(function(res) {
        if (res.code === 200) {
          this.getList()
          this.$message.success('删除成功')
        }
      }.bind(this)).catch(function() {})
    },
    statusLabel(status) {
      if (status === 0) return '未读'
      if (status === 1) return '已读'
      if (status === 2) return '已回复'
      return '未知'
    },
    statusTagType(status) {
      if (status === 0) return 'danger'
      if (status === 1) return 'warning'
      if (status === 2) return 'success'
      return 'info'
    }
  }
}
</script>

<style scoped lang="scss">
.table-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.search-container {
  margin-bottom: 0;
  padding: 20px;
  background-color: var(--background);
  border-radius: var(--border-radius);
  box-sizing: border-box;
  transition: all 0.3s ease;
}

.mobile-search-top {
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  margin-bottom: 0;
  padding: 10px 15px;
}

.desktop-search-wrapper {
  width: 100%;
}

.search-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.search-input {
  width: 100%;
  max-width: 400px;
  font-size: var(--font-size-sm);
}

.button-group {
  display: flex;
  align-items: center;
}

.filter-button {
  white-space: nowrap;
}

/* 筛选面板 */
.filter-panel {
  background-color: var(--bg-100);
  border: 1px solid var(--border);
  border-radius: var(--border-radius);
  padding: 15px;
  margin-top: 10px;
  box-shadow: var(--shadow);
}

.filter-row {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 15px;
}

.filter-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.filter-item label {
  font-size: var(--font-size-sm);
  font-weight: 500;
  color: var(--text);
}

.filter-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid var(--border);
}

.applied-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}

.filter-tag {
  background-color: var(--primary);
  color: white;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: var(--font-size-sm);
  display: inline-flex;
  align-items: center;
}

.filter-tag-empty {
  background-color: var(--bg-200);
  color: var(--text-200);
}

.filter-buttons {
  display: flex;
  gap: 10px;
}

/* 手机端筛选 */
.mobile-search-wrapper {
  width: 100%;
}

.mobile-applied-filters {
  padding: 10px 15px;
  background-color: var(--bg-100);
  border-radius: var(--border-radius);
  margin-bottom: 15px;
}

.mobile-filter-tag {
  background-color: var(--primary);
  color: white;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: var(--font-size-xs);
  display: inline-block;
}

.mobile-filter-tag.empty {
  background-color: var(--bg-200);
  color: var(--text-200);
}

.mobile-filter-panel {
  background-color: var(--bg-100);
  border: 1px solid var(--border);
  border-radius: var(--border-radius);
  margin-top: 10px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.mobile-filter-actions {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  padding: 10px 0;
  margin-top: 10px;
  border-top: 1px solid var(--border);
}

.mobile-filter-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 10px;
  margin-top: 10px;
  background-color: var(--bg-100);
  border: 1px solid var(--border);
  border-radius: var(--border-radius);
  font-size: var(--font-size-sm);
  color: var(--text-200);
  cursor: pointer;
  transition: all 0.2s ease;
}

.mobile-filter-toggle:hover {
  background-color: var(--border-light);
}

/* 内容区域 */
.content-container {
  flex: 1;
  height: 100%;
  overflow: hidden;
  padding: 20px 0;
  padding-bottom: 0;
  display: flex;
  flex-direction: column;
}

.table-wrapper {
  height: 100%;
  margin-bottom: 0;
  border-radius: var(--border-radius);
  overflow: hidden;
  box-shadow: var(--shadow);
  font-size: 14px;
}

.table-actions {
  width: 100%;
  display: inline-flex;
  justify-content: flex-end;
  gap: 10px;
  font-size: 14px;
}

.desktop-table {
  height: 100%;
  margin-bottom: 0;
  font-size: 14px;
}

/* 手机端卡片 */
.mobile-cards {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 0;
}

.mobile-card {
  border: 1px solid var(--border);
  border-radius: var(--border-radius-lg);
  padding: 15px;
  background-color: var(--bg-200);
  box-shadow: var(--shadow-sm);
  transition: all 0.3s ease;
  overflow: hidden;
  position: relative;
}

.mobile-card:hover {
  box-shadow: var(--shadow-lg);
  transform: translateY(-2px);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--border-light);
}

.card-title {
  display: flex;
  flex-direction: column;
  gap: 5px;
  flex: 1;
  margin-right: 10px;
}

.card-title h3 {
  margin: 0;
  font-size: var(--font-size-md);
  font-weight: 600;
  color: var(--text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.card-content {
  border-bottom: 1px solid var(--border-light);
  padding-bottom: 12px;
  margin-bottom: 12px;
}

.card-content p {
  margin: 8px 0;
  font-size: var(--font-size-sm);
  color: var(--text-200);
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  line-height: 1.6;
  flex-wrap: wrap;
}

.card-content p strong {
  color: var(--text);
  font-weight: 500;
  min-width: 80px;
  text-align: left;
  flex-shrink: 0;
}

.card-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  padding-top: 12px;
  flex-wrap: wrap;
  align-items: center;
}

.card-actions .van-button {
  font-size: 13px;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.mobile-empty {
  text-align: center;
  padding: 40px 0;
  color: var(--text-200);
  font-size: var(--font-size-sm);
}

/* 详情 - PC端 */
.detail-content {
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.detail-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-bottom: 20px;
  border-bottom: 1px solid var(--border-light, #ebeef5);
}

.detail-header-info {
  display: flex;
  align-items: center;
  gap: 14px;
}

.detail-avatar {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: linear-gradient(135deg, #409EFF, #66b1ff);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 24px;
  flex-shrink: 0;
}

.detail-header-text h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: var(--text, #303133);
  line-height: 1.4;
}

.detail-header-text p {
  margin: 4px 0 0;
  font-size: 13px;
  color: var(--text-200, #909399);
}

.detail-header-meta {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
  flex-shrink: 0;
}

.detail-time {
  font-size: 12px;
  color: var(--text-200, #909399);
}

/* 联系方式卡片 */
.detail-contact-card {
  background: var(--bg-100, #f5f7fa);
  border-radius: 10px;
  padding: 4px 0;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 20px;
  transition: background-color 0.2s;
}

.contact-item:hover {
  background-color: rgba(64, 158, 255, 0.04);
}

.contact-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  flex-shrink: 0;
}

.email-icon {
  background: linear-gradient(135deg, #e8f4fd, #d0ebff);
  color: #409EFF;
}

.phone-icon {
  background: linear-gradient(135deg, #e8f8ef, #d0f0e0);
  color: #67C23A;
}

.category-icon {
  background: linear-gradient(135deg, #fef3e8, #fde6c8);
  color: #E6A23C;
}

.location-icon {
  background: linear-gradient(135deg, #f0e8fd, #e0d0f5);
  color: #7B5CDB;
}

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.contact-label {
  font-size: 11px;
  color: var(--text-200, #909399);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 500;
}

.contact-value {
  font-size: 14px;
  color: var(--text, #303133);
  word-break: break-all;
}

/* 留言内容卡片 */
.detail-message-card {
  background: var(--bg-100, #f5f7fa);
  border-radius: 10px;
  padding: 20px;
}

.message-card-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 14px;
  font-size: 14px;
  font-weight: 600;
  color: var(--text, #303133);
}

.message-card-title i {
  color: #409EFF;
  font-size: 16px;
}

.detail-message-text {
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  font-size: 14px;
  line-height: 1.8;
  color: var(--text, #303133);
  white-space: pre-wrap;
  word-break: break-word;
  border: 1px solid var(--border-light, #ebeef5);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

/* 弹窗 - 移动端 */
.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 20px;
  background: #fff;
  border-bottom: 1px solid var(--border-light, #ebeef5);
  position: sticky;
  top: 0;
  z-index: 10;
}

.popup-user-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.popup-avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: linear-gradient(135deg, #409EFF, #66b1ff);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 20px;
  flex-shrink: 0;
}

.popup-user-text h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: var(--text, #303133);
}

.popup-user-text p {
  margin: 3px 0 0;
  font-size: 12px;
  color: var(--text-200, #909399);
}

.popup-content {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  background-color: var(--bg-200, #fafafa);
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.popup-status-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 2px;
}

.popup-time {
  font-size: 12px;
  color: var(--text-200, #909399);
}

/* 移动端联系方式列表 */
.popup-contact-list {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

.popup-contact-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
}

.popup-contact-item + .popup-contact-item {
  border-top: 1px solid var(--border-light, #ebeef5);
}

.popup-contact-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-shrink: 0;
}

.popup-contact-info {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}

.popup-contact-label {
  font-size: 11px;
  color: var(--text-200, #909399);
  font-weight: 500;
}

.popup-contact-value {
  font-size: 13px;
  color: var(--text, #303133);
  word-break: break-all;
}

/* 移动端留言卡片 */
.popup-message-card {
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

.popup-message-title {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 10px;
  font-size: 13px;
  font-weight: 600;
  color: var(--text, #303133);
}

.popup-message-title i {
  color: #409EFF;
  font-size: 15px;
}

.popup-message-text {
  background: var(--bg-100, #f5f7fa);
  border-radius: 8px;
  padding: 14px;
  font-size: 13px;
  line-height: 1.7;
  color: var(--text, #303133);
  white-space: pre-wrap;
  word-break: break-word;
}

/* 分页 */
.pagination-container {
  margin-top: 0;
  margin-bottom: 0;
  padding: 10px;
  border-top: 1px solid var(--border);
  text-align: right;
  box-sizing: border-box;
}

/* 响应式 */
@media (max-width: 768px) {
  .search-container {
    width: 100vw;
    margin-left: -15px;
    border-bottom-left-radius: var(--border-radius);
    border-bottom-right-radius: var(--border-radius);
    background-color: var(--bg-200);
  }

  .search-container .search-input {
    display: none;
  }

  .desktop-table {
    display: none;
  }

  .mobile-cards {
    display: flex;
  }

  .search-row {
    flex-direction: column;
    align-items: flex-start;
  }

  .search-input {
    max-width: 100%;
  }

  .filter-row {
    flex-direction: column;
    gap: 15px;
    align-items: flex-start;
  }

  .filter-item {
    width: 100%;
  }

  .filter-item .el-select {
    width: 100% !important;
  }

  .content-container {
    padding: 10px 0;
  }

  .pagination-container {
    text-align: center;
    padding: 15px;
  }
}

@media (min-width: 769px) {
  .search-container .mobile-search-container,
  .mobile-filter-toggle {
    display: none;
  }

  .desktop-table {
    display: block;
  }

  .mobile-cards {
    display: none;
  }
}
</style>

<style lang="scss">
/* Drawer 全局样式覆盖 */
.contact-detail-drawer .el-drawer__body {
  padding: 24px;
}
</style>
